/* Lista de deseos (wishlist) basada en localStorage. No requiere cuenta ni apps de pago.
   Guarda los "handles" de producto en el navegador del visitante. */
(function () {
  var STORAGE_KEY = 'mt_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage no disponible (modo privado, etc.) - fallamos en silencio */
    }
    updateCountBubbles(list.length);
    document.dispatchEvent(new CustomEvent('mt:wishlist:change', { detail: { list: list } }));
  }

  function updateCountBubbles(count) {
    var bubbles = document.querySelectorAll('[data-mt-wishlist-count]');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = count;
      bubbles[i].closest('.cart-count-bubble').hidden = count === 0;
    }
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1; /* true = recién añadido */
  }

  function refreshButtons() {
    var list = getWishlist();
    var buttons = document.querySelectorAll('.mt-wishlist-btn');
    for (var i = 0; i < buttons.length; i++) {
      var handle = buttons[i].getAttribute('data-handle');
      buttons[i].classList.toggle('is-active', list.indexOf(handle) !== -1);
    }
    updateCountBubbles(list.length);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mt-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    var nowFav = toggle(handle);
    var allForHandle = document.querySelectorAll('.mt-wishlist-btn[data-handle="' + handle + '"]');
    for (var i = 0; i < allForHandle.length; i++) {
      allForHandle[i].classList.toggle('is-active', nowFav);
    }
  });

  var HEART_ICONS =
    '<span class="mt-wishlist-btn__icon-outline svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"/></svg></span>' +
    '<span class="mt-wishlist-btn__icon-filled svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M10 17.5 8.55 16.18C3.4 11.36 0 8.28 0 4.5 0 1.42 2.42-1 5.5-1c1.74 0 3.41.81 4.5 2.09C11.09-.19 12.76-1 14.5-1 17.58-1 20 1.42 20 4.5c0 3.78-3.4 6.86-8.55 11.68L10 17.5Z" transform="translate(0 3)"/></svg></span>';

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function renderWishlistPage() {
    var grid = document.getElementById('mt-wishlist-grid');
    if (!grid) return;
    var list = getWishlist();

    if (!list.length) {
      grid.innerHTML = '<p class="mt-wishlist-empty">' + (grid.getAttribute('data-empty-text') || 'Your wishlist is empty.') + '</p>';
      return;
    }

    grid.innerHTML = '<p class="mt-wishlist-loading">' + (grid.getAttribute('data-loading-text') || 'Loading…') + '</p>';

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = '';
      var any = false;
      products.forEach(function (p, i) {
        if (!p) return;
        any = true;
        var handle = list[i];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var card = document.createElement('div');
        card.className = 'mt-wishlist-card';
        card.innerHTML =
          '<a href="/products/' + handle + '" class="mt-wishlist-card__media">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="mt-wishlist-card__info">' +
          '<a href="/products/' + handle + '" class="mt-wishlist-card__title">' + p.title + '</a>' +
          '<span class="mt-wishlist-card__price">' + formatMoney(p.price) + '</span>' +
          '</div>' +
          '<button type="button" class="mt-wishlist-btn mt-wishlist-btn--inline is-active" data-handle="' + handle + '" aria-label="Remove from wishlist">' +
          HEART_ICONS +
          '</button>';
        grid.appendChild(card);
      });
      if (!any) {
        grid.innerHTML = '<p class="mt-wishlist-empty">' + (grid.getAttribute('data-empty-text') || 'Your wishlist is empty.') + '</p>';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons();
    renderWishlistPage();
  });
  document.addEventListener('mt:wishlist:change', function () {
    refreshButtons();
    renderWishlistPage();
  });

  window.mtWishlist = { get: getWishlist, toggle: toggle };
})();
